import ComponentManager from '@/Management/ComponentManager';
import DatePickerViewModel from '@/ViewModels/Controls/DatePickerViewModel';
import DatePicker from '@/Controls/DatePicker';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import DatePickerFactoryBase from '@/Factories/ControlFactories/DatePickerFactoryBase';
import TypeConverter from '@/Utility/TypeConverter';

export default class DatePickerFactory extends DatePickerFactoryBase {

    private jQueryControl: JQuery;
    private DatePickerViewModel = ComponentManager.getViewModel<typeof DatePickerViewModel>('DatePickerViewModel');
    private DatePicker = ComponentManager.getControl<typeof DatePicker>('DatePicker');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: DatePickerViewModel;

    /**
     * @override
     */
    control: DatePicker;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.detailViewItem.viewModel || new this.DatePickerViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        });

        this.control = new this.DatePicker(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);

        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.value, (value: string): boolean => {
            // Keine Validierung, wenn der Wert nicht in den Changes ist
            if (Object.keys(this.context.genericObject.changes()).indexOf(this.detailViewItem.name) == -1)
                return true;

            const isNullableType = TypeConverter.typeIsNullable(this.detailViewItem.dotNetTypeName) || this.detailViewItem.useInFilter;
            const validityState = (this.jQueryControl.find('input')[0] as HTMLInputElement)?.validity;
            
            // Liegt ein DerivedOverwritable Property vor UND der neue Wert ist 'null', dann validieren wir erstmal nicht.
            // Eine erneute Validierung triggert, sobald bspw. ein neuer Wert gesetzt wurde
            if (this.detailViewItem.isDerivedOverwritable && value === null)
                return true;
            
            if (!validityState?.valid) return false;
            return this.viewModel.customValidate(value, isNullableType);
        });

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('DatePicker', DatePickerFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');